import"./TabHeader.css.ts.vanilla.css";var e="_19epwem0",a="_19epwem2",r="_19epwem1";export{e as li,a as tabHeader,r as tabHeaderContainer};
